@if (isReady() && isSupported()) {
  <apple-pay-button
    buttonstyle="black"
    type="plain"
    id="select-apple-pay-payment"
    data-testid="payment-apple-pay-btn"
    class="apple-pay__button"
    (click)="startPayment()"
  >
  </apple-pay-button>
} @else if (isSupported()) {
  <div>
    <img class="payment-spinner" [src]="spinner" alt="Loading" />
  </div>
}
